import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "heading3 h3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "(*)", -1)
const _hoisted_5 = { class: "sr-only" }

import { ref, onMounted } from 'vue'
  import { Translate } from '@/locale'
  import type { Rules,SectionState } from "@/types";
  import EventBus from '@/composables/EventBus'

  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    description: null,
    sectionId: null,
    validate: { type: Boolean }
  },
  emits: ["addErrorId", "get-dependency"],
  setup(__props: any, { emit }: { emit: ({
    (e:'addErrorId', sectionId: string):void
    (e:'get-dependency', rules: Rules):void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    title?: string,
    description?: string,
    sectionId?: string,
    validate?: boolean
  }

  

  


  // ---  DATA ---
  const value = ref<string>("")
  const id = ref<string>("")
  const state = ref<string>("")
  const checked =  ref<boolean>(false)

  // --- Lifecycle ---
  onMounted(() => {
    if (props.validate) {
      EventBus.emit('addErrorId', props.sectionId!);
    }

    EventBus.on('get-section-dependency', (obj:SectionState) => {

      if (props.sectionId === obj.section) {
          value.value = obj.value;
          id.value = obj.forId;
          state.value = obj.state;
          checked.value = true

          let rules:Rules = {
            forId : id.value,
            checked  :true,
            state:  state.value
          };

        EventBus.emit('get-dependency', rules);
      }
    })


  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "evaluation__section",
    id: __props.sectionId
  }, [
    _createElementVNode("fieldset", null, [
      _createElementVNode("legend", _hoisted_2, [
        _createTextVNode(_toDisplayString(__props.title) + " ", 1),
        (__props.validate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(Translate)('required')), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}
}

})